import { TraversalState } from "../engine/internal";
/**
 * This is the base class of scenegraph tree. This is an abstact class that has to be extended in a concrete implementation.
 * @class Scene
 * @constructor
 */
export class Scene {
    constructor(engine) {
        this.renderDeltaTime = 0;
        /**
         * Events that are triggered before rendering the scene
         * @property registeredTraversalEvents
         * @private
         */
        this._registeredTraversalEvents = {};
        /**
         * If True the scene will be rendered at maxium frame rate
         * @property {boolean} renderContinuously
         */
        this.renderContinuously = false;
        this.engine = engine;
        this.nodes = [];
        this.traversalState = new TraversalState(this);
    }
    /**
     * @method add
     * @param {SceneGraphNode} node
     * @param {Object} options
     * @example
     *  <code>scene.add(new Box(), null);</code>
     * @return {Boolean} Returns true on success
     */
    add(node, options = {}) {
        node.init(this.traversalState);
        this.nodes.push(node);
        return true;
    }
    remove(node) {
        for (let i = 0; i < this.nodes.length; i++) {
            if (node == this.nodes[i]) {
                this.nodes.splice(i, 1);
            }
        }
    }
    /**
     * Register a function that is called every render cycle before the scene is renderer
     * @method registerTraversalEvent
     * @param id
     * @param eventFunction
     */
    registerTraversalEvent(id, eventFunction) {
        this._registeredTraversalEvents[id] = function (deltaTime) {
            eventFunction(deltaTime);
        };
    }
    /**
     * Remove event registration
     * @method unregisterTraversalEvent
     * @param id
     */
    unregisterTraversalEvent(id) {
        this._registeredTraversalEvents[id] = null;
    }
    render() {
        this.renderDeltaTime = this.engine.clock.getDelta();
        for (const key in this._registeredTraversalEvents) {
            if (this._registeredTraversalEvents[key] != null) {
                this._registeredTraversalEvents[key](this.renderDeltaTime);
            }
        }
    }
    /**
     * Render at maximum frame rate. Performance problem may be caused
     * @method contiuousRendering
     * @param enabled
     */
    continuousRendering(enabled) {
        this.renderContinuously = enabled;
    }
    /**
     * Trigger update on the scene (For instance after updating centroid)
     * @method update
     */
    update() {
        for (let i = 0; i < this.nodes.length; i++) {
            this.nodes[i].update();
        }
    }
}
//# sourceMappingURL=scene.js.map